import React, { Fragment } from 'react';
import { isValid, scrollToTopOf } from '../../../../utils';
import './table-of-contents.scss';

const TableOfContents = ({
    className,
    hedUrl,
    isPage,
    isMobile,
    data,
}) => {
  const {
    header,
    TOC,
  } = data;

  const isCommercePolicyPage = (isValid(hedUrl) && hedUrl === 'commerce-policy');

  const handleScroll = (sectionUrl) => {
    const element = `#${sectionUrl}`;
    // console.log(`Link clicked, should scroll to ${element}`);
    scrollToTopOf(element, 80, 100);
  };

  const renderTOCList = () => {
    let renderedContents;
    let renderedMoreContents;
    if (isValid(TOC)){
      let { length } = TOC;
      if (isMobile || length <= 3) {
        renderedContents = TOC.map((section, i) => {
          let sectionUrl = section.url;
          return (
            <>
              {isValid(sectionUrl) &&
                <li className='label-item' key={`section${i}`}>
                    <a className='label-link' href={`#${sectionUrl}`} onClick={() => handleScroll(sectionUrl)}>
                      <h4 className='label-text'>{section.label}</h4>
                    </a>
                </li>
              }
            </>
          );
        });
        return (
          <ul className='labels-list'>{renderedContents}</ul>
        );
      } else {
        const TOC1 = (length === 4) ? TOC.slice(0,2) : TOC.slice(0,3);
        const TOC2 = (length === 4) ? TOC.slice(2) : TOC.slice(3);
        renderedContents = TOC1.map((section, i) => {
          let sectionUrl = section.url;
          return (
            <>
              {isValid(sectionUrl) &&
                <li className='label-item' key={`section${i}`}>
                    <a className='label-link' href={`#${sectionUrl}`} onClick={() => handleScroll(sectionUrl)}>
                      <h4 className='label-text'>{section.label}</h4>
                    </a>
                </li>
              }
            </>
          );
        });
        renderedMoreContents = TOC2.map((section, i) => {
          let sectionUrl = section.url;
          return (
            <>
              {isValid(sectionUrl) &&
                <li className='label-item' key={`section${(i+3)}`}>
                    <a className='label-link' href={`#${sectionUrl}`} onClick={() => handleScroll(sectionUrl)}>
                      <h4 className='label-text'>{section.label}</h4>
                    </a>
                </li>
              }
            </>
          );
        });
        return (
          <div className='toc-list-container'>
            <ul className='labels-list'>{renderedContents}</ul>
            <ul className='labels-list second-list'>{renderedMoreContents}</ul>
          </div>
        );
      }
    } else {
      return null;
    }
  };

  // TOC links specific to Commerce Policy Page only
  const commercePolicyTOC = [
    { label: 'Why You Should Trust Us', url: 'why-you-should-trust-us' },
    { label: 'How We Test Products', url: 'how-we-test-products' },
    { label: 'How We Find Deals', url: 'how-we-find-deals' },
    { label: 'How We Make Money', url: 'how-we-make-money' },
    { label: 'What Our PureWow100 Ratings Mean', url: 'what-our-purewow100-ratings-mean' },
    { label: 'Safety', url: 'safety' },
    { label: 'Meet Our Team', url: 'meet-our-team' },
    { label: 'Contact Us', url: 'contact-us' },
  ];

  const transformTOCCommerceArray = (arr) => {
    const columnDivider = <hr className='hr-line'></hr>;
    let newArr = !isMobile ? arr.splice(3, 0, columnDivider) : arr;
    newArr = !isMobile ? arr.splice(7, 0, columnDivider) : arr;
    return newArr;
  };
  const transformedTOCCommerce = transformTOCCommerceArray(commercePolicyTOC);

  const renderTOCListCommercePolicy = () => {
    const renderedContents = commercePolicyTOC.map((section, i) => {
      const sectionUrl = section.url;
      return (
        <>
          {isValid(sectionUrl) &&
            <li className='label-item' key={section[i]}>
                <a className='label-link' href={`#${sectionUrl}`} onClick={() => handleScroll(sectionUrl)}>
                  <h4 className='label-text'>{section.label}</h4>
                </a>
            </li>
          }
          {(!isValid(sectionUrl) && (i === 3 || i === 7) && !isMobile) &&
            <li className='label-item' key={section[i]}>
              <hr className='hr-line-comm'></hr>
            </li>
          }
        </>
      )
    });
    return (
      <ul className='labels-list'>{renderedContents}</ul>
    );
  };
  
  const renderedTOCList = renderTOCList();
  const renderedTOCListCommercePolicy = renderTOCListCommercePolicy();
  return (
        <Fragment>
            <div className={className}>
                <p className='toc-header'>{header}</p>
                
                  {!isCommercePolicyPage && renderedTOCList}
                  {(isPage && isCommercePolicyPage) && renderedTOCListCommercePolicy}
                
            </div>
        </Fragment>
  );
};

export default TableOfContents;
